// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2YlKP","ranges":"BmiRanges_ranges__3jm8B"};